export default "__VITE_ASSET__DO95X7j4__"